document.addEventListener('DOMContentLoaded', function() {
  if (window.__personalizationModalMergedInitialized) {
    return;
  }
  window.__personalizationModalMergedInitialized = true;

  var TRIGGER_SELECTOR = '#personalize-button, [data-personalize-trigger]';
  var MODAL_SELECTOR = '#personalization-modal, [data-personalization-modal]';
  var MODAL_OPEN_CLASS = 'is-open';

  function qs(selector, context) {
    return (context || document).querySelector(selector);
  }

  function qsa(selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  }

  function sanitizeEngraving(value) {
    return String(value || '')
      .toUpperCase()
      .replace(/\s+/g, '')
      .replace(/[^A-Z0-9.,:«()!?+\-*/=]/g, '')
      .slice(0, 3);
  }
  function getModalFromTrigger(trigger) {
    var targetSelector = trigger.getAttribute('data-personalization-target');
    if (targetSelector) {
      return qs(targetSelector);
    }

    var nearestScopedModal = qs(MODAL_SELECTOR, trigger.closest('[data-personalization-scope]'));
    if (nearestScopedModal) {
      return nearestScopedModal;
    }

    return qs(MODAL_SELECTOR);
  }

  function getProductVariants(modal) {
    if (modal && Array.isArray(modal.__productVariants)) {
      return modal.__productVariants;
    }

    if (modal && modal.dataset.productVariants) {
      try {
        modal.__productVariants = JSON.parse(modal.dataset.productVariants);
        return modal.__productVariants;
      } catch (error) {
        console.error('[personalization] invalid data-product-variants', error);
      }
    }
     if (Array.isArray(window.productVariants)) {
      return window.productVariants;
    }

    return [];
  }

  function ensureModalReady(modal) {
    if (!modal) {
      return null;
    }

    if (!document.body.contains(modal) || modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    if (!modal.__personalizationState) {
      modal.__personalizationState = {
        selectedOptions: {},
        initialized: false
      };
    }

    return modal.__personalizationState;
  }
  function getElements(modal) {
    return {
      closeButton: qs('.perfume-modal__close', modal),
      engravingInput: qs('#engraving-input, [data-engraving-input]', modal),
      engravingPreview: qs('#engraving-preview, [data-engraving-preview]', modal),
      confirmButton: qs('#confirm-personalization, [data-confirm-personalization]', modal),
      giftCheckbox: qs('#gift-wrap-checkbox, [data-gift-wrap-checkbox]', modal),
      optionContainers: qsa('.perfume-modal__option-values', modal)
    };
  }

  function syncPreview(modal) {
    var elements = getElements(modal);
    if (!elements.engravingInput || !elements.engravingPreview) {
      return;
    }

    var value = sanitizeEngraving(elements.engravingInput.value);
    elements.engravingInput.value = value;
    elements.engravingPreview.textContent = value;
  }
function buildSelectedOptions(modal) {
    var state = ensureModalReady(modal);
    var elements = getElements(modal);

    elements.optionContainers.forEach(function(container) {
      var optionIndex = parseInt(container.getAttribute('data-option-index') || '0', 10);
      var activeButton = qs('.perfume-modal__option-value.active', container);
      var fallbackButton = qs('.perfume-modal__option-value:not(.disabled)', container) || qs('.perfume-modal__option-value', container);

      if (activeButton) {
        state.selectedOptions[optionIndex] = activeButton.getAttribute('data-value');
      } else if (fallbackButton) {
        fallbackButton.classList.add('active');
        state.selectedOptions[optionIndex] = fallbackButton.getAttribute('data-value');
      }
    });
  }
function findSelectedVariant(modal) {
    var state = ensureModalReady(modal);
    var variants = getProductVariants(modal);
    var optionIndexes = Object.keys(state.selectedOptions)
      .map(function(key) { return parseInt(key, 10); })
      .sort(function(a, b) { return a - b; });
    var selectedValues = optionIndexes.map(function(index) {
      return state.selectedOptions[index];
    });

    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var isMatch = true;

      for (var j = 0; j < selectedValues.length; j++) {
        if (variant.options[j] !== selectedValues[j]) {
          isMatch = false;
          break;
        }
      }

      if (isMatch) {
        return variant;
      }
    }

    return null;
  }
  function updateOptionAvailability(modal) {
    var state = ensureModalReady(modal);
    var elements = getElements(modal);
    var variants = getProductVariants(modal);
    var optionIndexes = Object.keys(state.selectedOptions)
      .map(function(key) { return parseInt(key, 10); })
      .sort(function(a, b) { return a - b; });

    elements.optionContainers.forEach(function(container) {
      var optionIndex = parseInt(container.getAttribute('data-option-index') || '0', 10);
      var buttons = qsa('.perfume-modal__option-value', container);

      buttons.forEach(function(button) {
        var testedValues = optionIndexes.map(function(index) {
          return index === optionIndex ? button.getAttribute('data-value') : state.selectedOptions[index];
        });

        var variantExists = variants.some(function(variant) {
          for (var i = 0; i < testedValues.length; i++) {
            if (variant.options[i] !== testedValues[i]) {
              return false;
            }
          }
          return !!variant.available;
        });
        button.classList.toggle('disabled', !variantExists);
        button.disabled = !variantExists;
      });
    });
  }

  function updateVariant(modal) {
    var elements = getElements(modal);
    var selectedVariant = findSelectedVariant(modal);

    if (!elements.confirmButton) {
      return;
    }

    if (selectedVariant && selectedVariant.available) {
      elements.confirmButton.disabled = false;
      elements.confirmButton.textContent = 'Ajouter au panier';
      elements.confirmButton.setAttribute('data-variant-id', selectedVariant.id);
    } else {
      elements.confirmButton.disabled = true;
      elements.confirmButton.textContent = 'Indisponible';
      elements.confirmButton.removeAttribute('data-variant-id');
    }

    updateOptionAvailability(modal);
  }
  function initializeVariantOptions(modal) {
    var state = ensureModalReady(modal);
    var elements = getElements(modal);

    state.selectedOptions = {};

    elements.optionContainers.forEach(function(container) {
      var buttons = qsa('.perfume-modal__option-value', container);
      var firstEnabled = buttons.find(function(button) {
        return !button.disabled;
      }) || buttons[0];

      buttons.forEach(function(button) {
        button.classList.remove('active');
      });

      if (firstEnabled) {
        firstEnabled.classList.add('active');
      }
    });

    buildSelectedOptions(modal);
    updateVariant(modal);
    state.initialized = true;
  }
  function openModal(modal) {
    if (!modal) {
      return;
    }

    ensureModalReady(modal);
    modal.style.display = 'block';
    modal.classList.add(MODAL_OPEN_CLASS);
    document.body.style.overflow = 'hidden';
    initializeVariantOptions(modal);
    syncPreview(modal);
  }

  function closeModal(modal) {
    if (!modal) {
      return;
    }

    modal.style.display = 'none';
    modal.classList.remove(MODAL_OPEN_CLASS);
    document.body.style.overflow = '';
  }

  function refreshDrawerFallback() {
    return fetch('/cart?_=' + Date.now(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store'
    })
    .then(function(response) {
        return response.text();
      })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newDrawer = qs('cart-drawer', doc);
        var currentDrawer = qs('cart-drawer');

        if (newDrawer && currentDrawer) {
          currentDrawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
          currentDrawer.innerHTML = newDrawer.innerHTML;
          if (typeof currentDrawer.open === 'function') {
            currentDrawer.open();
          }
        }

        var newBubble = qs('#cart-icon-bubble', doc);
        var currentBubble = qs('#cart-icon-bubble');
        if (newBubble && currentBubble) {
          currentBubble.innerHTML = newBubble.innerHTML;
        }
      });
  }
  function addToCart(items) {
    if (window.CartDrawerAPI && typeof window.CartDrawerAPI.add === 'function') {
      return window.CartDrawerAPI.add(items, { open: true });
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(err) {
            throw new Error(err.description || 'cart/add error');
          });
        }
        return response.json();
      })
      .then(function() {
        if (qs('cart-drawer')) {
          return refreshDrawerFallback();
        }
        window.location.href = '/cart';
      });
  }

  document.addEventListener('click', function(event) {
    var trigger = event.target.closest(TRIGGER_SELECTOR);
    if (trigger) {
      event.preventDefault();
      openModal(getModalFromTrigger(trigger));
      return;
    }

    var closeButton = event.target.closest('.perfume-modal__close');
    if (closeButton) {
      event.preventDefault();
      closeModal(closeButton.closest(MODAL_SELECTOR));
      return;
    }
    var optionButton = event.target.closest('.perfume-modal__option-value');
    if (optionButton) {
      event.preventDefault();
      if (optionButton.disabled || optionButton.classList.contains('disabled')) {
        return;
      }

      var optionContainer = optionButton.closest('.perfume-modal__option-values');
      var modal = optionButton.closest(MODAL_SELECTOR);
      if (!optionContainer || !modal) {
        return;
      }

      qsa('.perfume-modal__option-value', optionContainer).forEach(function(button) {
        button.classList.remove('active');
      });
      optionButton.classList.add('active');

      buildSelectedOptions(modal);
      updateVariant(modal);
      return;
    }
    var confirmButton = event.target.closest('#confirm-personalization, [data-confirm-personalization]');
    if (confirmButton) {
      event.preventDefault();

      var modal = confirmButton.closest(MODAL_SELECTOR);
      var elements = getElements(modal);
      var engravingText = sanitizeEngraving(elements.engravingInput && elements.engravingInput.value);
      var isGiftSelected = !!(elements.giftCheckbox && elements.giftCheckbox.checked);
      var variantId = confirmButton.getAttribute('data-variant-id');

      if (!engravingText.length) {
        alert('Veuillez entrer votre texte.');
        return;
      }

      if (!/^[A-Z0-9.,:«()!?+\-*/=]{1,3}$/.test(engravingText)) {
        alert('Seules les lettres, les chiffres, et les caractères spéciaux autorisés sont permis.');
        return;
      }

      if (!variantId) {
        alert('Cette combinaison est indisponible.');
        return;
      }
      var originalLabel = confirmButton.textContent;
      confirmButton.disabled = true;
      confirmButton.textContent = 'Ajout en cours...';

      addToCart([{
        id: variantId,
        quantity: 1,
        properties: {
          'Texte gravé': engravingText,
          'Emballage Cadeau': isGiftSelected ? 'Oui' : 'Non'
        }
      }])
        .then(function() {
          closeModal(modal);
        })
        .catch(function(error) {
          alert('Erreur : ' + (error && error.message ? error.message : 'ajout impossible'));
        })
        .finally(function() {
          confirmButton.disabled = false;
          confirmButton.textContent = originalLabel;
        });
    }
  });

  document.addEventListener('input', function(event) {
    var input = event.target.closest('#engraving-input, [data-engraving-input]');
    if (!input) {
      return;
    }
    syncPreview(input.closest(MODAL_SELECTOR));
  });

  document.addEventListener('keypress', function(event) {
    var input = event.target.closest('#engraving-input, [data-engraving-input]');
    if (!input) {
      return;
    }

    var char = String.fromCharCode(event.which);
    if (!/^[a-zA-Z0-9.,:«()!?+\-*/=]+$/.test(char)) {
      event.preventDefault();
    }
  });

  window.addEventListener('click', function(event) {
    var modal = event.target.closest(MODAL_SELECTOR);
    if (modal && event.target === modal) {
      closeModal(modal);
    }
  });
});